import BackendAPI from '~/api/BackendClient/BackendAPI'
import { components } from '~/api/BackendClient/generated-schema'

export type DefaultSuccessResponse = components['schemas']['DefaultSuccessResponse']

class UserAPI extends BackendAPI {
  invalidateTokens = (): Promise<DefaultSuccessResponse> =>
    this.client.POST('/api/user/invalidate-tokens')
}

export default UserAPI
